import { render, staticRenderFns } from "./OtherIntegrations.vue?vue&type=template&id=0855de12&"
import script from "./OtherIntegrations.vue?vue&type=script&lang=js&"
export * from "./OtherIntegrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/monbi/bbx/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0855de12')) {
      api.createRecord('0855de12', component.options)
    } else {
      api.reload('0855de12', component.options)
    }
    module.hot.accept("./OtherIntegrations.vue?vue&type=template&id=0855de12&", function () {
      api.rerender('0855de12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/OtherIntegrations.vue"
export default component.exports